import { ReactElement } from 'react'
import styled from 'styled-components'

const Svg = styled.svg``

interface ICirclePinIconProps {
  className?: string
  fillColor?: string
  width?: number
  height?: number
}

export const CirclePinIcon = ({
  className,
  fillColor = '#916EE8',
  width = 32,
  height = 32
}: ICirclePinIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32" className={className}>
      <circle opacity="0.2" cx="16" cy="16" r="16" fill={fillColor} />
      <circle cx="16.5" cy="15.5" r="7.5" fill={fillColor} />
    </Svg>
  )
}
